import { notification as antdNotification } from "antd";
import uniqueId from "lodash/uniqueId";
import classNames from "classnames";
import { getNotification } from "../../utils/appStaticFunctions";

const getNotificationInstance = () => getNotification() || antdNotification;

export const openNotification = (params = {}) => {
  const {
    message,
    title,
    description,
    type = "open",
    placement = "topRight",
    key = uniqueId("_notification_key_"),
    duration = 3,
    closeIcon = <i className="ti-close" />,
    className,
    ...rest
  } = params;

  getNotificationInstance()[type]({
    key,
    placement,
    title: title || message,
    description,
    duration,
    closeIcon,
    className: classNames("antd-custom-notification", className, { "no-description": !description }),
    ...rest
  });
};

export const openGeneralErrorNotification = (params) => {
  const {
    className,
    error,
    placement = "topRight",
    key = uniqueId("_notification_key_"),
    duration = 3,
    closeIcon = <i className="ti-close" />,
    defaultError = "",
    ...rest
  } = params;

  const message =
    error?.response?.data?.errors?.general?.length > 0 ? error.response.data.errors.general[0] : defaultError;

  if (message) {
    getNotificationInstance().error({
      key,
      placement,
      title: message,
      duration,
      closeIcon,
      className: classNames("antd-custom-notification no-description", className),
      ...rest
    });
  }
};
